module.exports = __webpack_public_path__ + "img/1F4AD.b3f2a9cc.svg";